module.exports = __webpack_public_path__ + "static/media/RajPritySabharwal.f2cb3e80.png";